import { Component, Input } from "@angular/core";
import { SkuAge } from "../../core/enums";

@Component({
  selector: "app-portfolio-accordion",
  templateUrl: "./portfolio-accordion.component.html",
  styleUrls: ["./portfolio-accordion.component.scss"],
  standalone: false,
})
export class PortfolioAccordionComponent {
  @Input() skuAge: string = "";
  @Input() subHeading: string = "";
  showAccordionContent: boolean = false;
  _skuAge = SkuAge;

  activeIndexChange(index: any) {
    if (index === 0) {
      this.showAccordionContent = true;
    } else {
      this.showAccordionContent = false;
    }
  }
}
